/**
 * 首页长文 HTML（站内维护；由 OgHomeArticle 渲染，勿拼接用户输入）
 */
export const introHtml = `
<div class="og-rich">
  <p>Ever opened WhatsApp and wished you could hide your online status from that one contact? Or customize the look of your chats to match your style? Maybe you need to use two WhatsApp accounts on one phone without juggling devices.</p>
  <p>That’s where OG WhatsApp comes in. It’s not the official WhatsApp—but it’s a modified version (mod) that many users choose when they want more control over privacy and layout. No fluff, no unnecessary features—just more options for how your messaging experience feels day to day.</p>
  <p>If you’re tired of feeling limited by the official app, keep reading. We’ll break down exactly what OG WhatsApp is, how to safely <strong>download OG WhatsApp latest version</strong>, and why its features matter in real life. Plus, we’ll be honest about the risks (no hidden fine print) and show you how to use it more safely.</p>
</div>
`;

export const fileInfoTableHtml = `
<table class="og-content-table">
  <thead>
    <tr><th scope="col">Field</th><th scope="col">Details</th></tr>
  </thead>
  <tbody>
    <tr><td>App Name</td><td>OG WhatsApp Pro</td></tr>
    <tr><td>Current Version</td><td>v18.80 (Latest 2026 Update)</td></tr>
    <tr><td>File Type</td><td><strong>OG WhatsApp APK</strong> (Android Package Kit)</td></tr>
    <tr><td>File Size</td><td>72 MB</td></tr>
    <tr><td>Required OS</td><td>Android 5.0 or higher</td></tr>
    <tr><td>Anti-Ban</td><td>Yes (reduces risk; not a guarantee—see FAQ)</td></tr>
    <tr><td>Updated On</td><td>March 2026</td></tr>
    <tr><td>Developer</td><td>Independent mod developers (not affiliated with Meta)</td></tr>
  </tbody>
</table>
`;

export const comparisonTableHtml = `
<table class="og-content-table og-content-table--compare">
  <thead>
    <tr><th scope="col">Feature</th><th scope="col">OG WhatsApp</th><th scope="col">Simple WhatsApp</th></tr>
  </thead>
  <tbody>
    <tr><td>Dual accounts</td><td>Yes</td><td>No (needs cloning / second device)</td></tr>
    <tr><td>Status length</td><td>Up to 5 minutes (build-dependent)</td><td>30 seconds</td></tr>
    <tr><td>Status download</td><td>Yes</td><td>No</td></tr>
    <tr><td>Hide status view</td><td>Yes</td><td>No</td></tr>
    <tr><td>Customization</td><td>Extensive (themes, fonts, bubbles)</td><td>Limited</td></tr>
    <tr><td>Media limits</td><td>Higher caps on many builds</td><td>Lower default caps</td></tr>
    <tr><td>Anti-ban tooling</td><td>Often advertised on mods</td><td>N/A (official)</td></tr>
    <tr><td>Pin chats</td><td>More pins on many builds</td><td>3 pins</td></tr>
    <tr><td>Group name length</td><td>Longer on many builds</td><td>25 characters</td></tr>
    <tr><td>Schedule messages</td><td>Common on mods</td><td>No</td></tr>
  </tbody>
</table>
`;

export const bodyAfterIntroHtml = `
<h2>What is OGWhatsApp?</h2>
<div class="og-rich">
  <p>OG WhatsApp is a modified version of the official WhatsApp Messenger, built by independent developers to add features the official app doesn’t offer. It’s not affiliated with Meta (the company that owns WhatsApp) and isn’t available on the Google Play Store or Apple App Store.</p>
  <p>But here’s the key: it keeps the core functionality you already expect from WhatsApp. You can send messages, make calls, share photos, and use the basics—plus extra tools that many people use for privacy, personalization, and dual-account setups.</p>
  <p>Think of it as “WhatsApp with more knobs” for people who want more control. For example: if you’re a small business owner who needs two WhatsApp accounts (one for work, one for personal), OG WhatsApp can help you do that on a single phone—when your build supports it.</p>
</div>
<div class="og-callout og-callout--important">
  <span class="og-callout__icon" aria-hidden="true">!</span>
  <div><strong>Important:</strong> OG WhatsApp is not official. We never claim it is—and you should still follow safe sideload habits to reduce account and security risks.</div>
</div>

<h2>OGWhatsApp Pro File Information</h2>
<div class="og-rich">
  <p>Before you start an <strong>OG WhatsApp download</strong>, it helps to know the file details so you can spot wrong filenames or suspicious sizes. Here’s the latest info for <strong>2026</strong>:</p>
  <p><strong>Why does this matter?</strong> File size helps you plan storage; OS requirements tell you if the phone is compatible; “anti-ban” wording is about risk reduction—not a promise of zero enforcement.</p>
  <p>Ready to get started? Jump to the <a href="/download/">download page</a> or keep reading for features and setup.</p>
</div>
<!--TABLE_PLACEHOLDER_FILEINFO-->

<h2>How to Download and Install OG WhatsApp?</h2>
<div class="og-rich">
  <p>Downloading and installing OG WhatsApp is straightforward—but you should follow the steps carefully. Since it’s not on the Play Store, you’ll sideload an <strong>OG WhatsApp APK</strong> from a source you trust (like ogbwhats.com).</p>
</div>
<div class="og-callout og-callout--warning">
  <span class="og-callout__icon" aria-hidden="true">⚠</span>
  <div><strong>Safety note:</strong> Avoid random pop-ups and “too good to be true” mirrors. Prefer this site’s download entry point and verify the file when you can.</div>
</div>
<ol class="og-install-timeline">
  <li class="og-install-timeline__item">
    <div class="og-install-timeline__marker">1</div>
    <div class="og-install-timeline__body">
      <h3 class="og-install-timeline__title">Prepare your phone</h3>
      <p>Android may block installs from unknown sources by default. Open <strong>Settings</strong> → <strong>Privacy / Security</strong> → <strong>Install unknown apps</strong>, pick your browser, and allow installs temporarily.</p>
      <div class="og-callout og-callout--tip"><span class="og-callout__icon" aria-hidden="true">✓</span><div><strong>Pro tip:</strong> Turn the permission off again after installation.</div></div>
    </div>
  </li>
  <li class="og-install-timeline__item">
    <div class="og-install-timeline__marker">2</div>
    <div class="og-install-timeline__body">
      <h3 class="og-install-timeline__title">Download the OG WhatsApp APK</h3>
      <p>On your phone, open your browser and go to <strong>ogbwhats.com</strong>. Use the download button on the <a href="/download/">download page</a>. The APK is listed around <strong>72 MB</strong> for the build described here—if the size looks wildly different, pause and re-check the source.</p>
    </div>
  </li>
  <li class="og-install-timeline__item">
    <div class="og-install-timeline__marker">3</div>
    <div class="og-install-timeline__body">
      <h3 class="og-install-timeline__title">Install the APK</h3>
      <p>Open <strong>Downloads</strong>, tap the APK (often named like <code>OGWhatsApp_v18.80.apk</code>), confirm <strong>Install</strong>, and wait until you see success.</p>
    </div>
  </li>
  <li class="og-install-timeline__item">
    <div class="og-install-timeline__marker">4</div>
    <div class="og-install-timeline__body">
      <h3 class="og-install-timeline__title">Set up OG WhatsApp</h3>
      <p>Open the app, enter your number, verify OTP, and restore chats if you’re switching from official WhatsApp and your backup path supports it. Finish profile name/photo and you’re in.</p>
    </div>
  </li>
</ol>
<div class="og-rich"><p>Ready to download? Use our <a href="/download/">latest OG WhatsApp APK</a> page for the newest file notes.</p></div>

<h2>Screenshots</h2>
<!--OG_HOME_SCREENSHOTS-->

<h2>OG WhatsApp APK Features</h2>
<div class="og-rich"><p><strong>OG WhatsApp</strong> is built around the stuff people actually complain about in stock chat apps: privacy, media limits, and juggling more than one number. What you get depends on the fork you install—the list below is what <strong>OG WhatsApp</strong> builds often aim for.</p></div>

<h3>OG WhatsApp Communities</h3>
<div class="og-rich"><p>In <strong>OG WhatsApp</strong>, communities help you bundle related groups under one roof—clubs, teams, small orgs. People join the umbrella and pick sub-groups so announcements don’t get lost across a dozen separate chats.</p></div>

<h3>OG WhatsApp Channels</h3>
<div class="og-rich"><p><strong>OG WhatsApp</strong> keeps the channel idea for one-way updates—hours, promos, news—without replies flooding your inbox. Exact extras still depend on the developer behind your APK.</p></div>

<h3>Avatar in OG WhatsApp</h3>
<div class="og-rich"><p><strong>OG WhatsApp</strong> avatar tools are for cartoon-style profile shots and stickers when you want personality without dropping a real photo in every group.</p></div>

<h3>Anti-ban APK</h3>
<div class="og-rich"><p>Many <strong>OG WhatsApp</strong> releases advertise anti-ban tweaks. Read that as <strong>risk reduction</strong>, not a guarantee—enforcement changes. Stay on a build you trust, skip spammy habits, and skim our FAQ.</p></div>
<div class="og-callout og-callout--warning"><span class="og-callout__icon" aria-hidden="true">⚠</span><div>No mod can guarantee zero enforcement risk.</div></div>

<h3>Status Download</h3>
<div class="og-rich"><p>On <strong>OG WhatsApp</strong>, you can often save photo or video statuses when the build allows—handy for family clips you’re cleared to keep. Still respect consent and copyright.</p></div>

<h3>Hide Status View</h3>
<div class="og-rich"><p><strong>OG WhatsApp</strong> can let you watch a status without popping up on the “viewed” list—low-drama scrolling when the toggle exists in your version.</p></div>

<h3>Anti Delete Status</h3>
<div class="og-rich"><p>Some <strong>OG WhatsApp</strong> forks keep a local copy of statuses you already opened—useful when someone deletes something you still need to reference.</p></div>

<h3>Disable Contact Status</h3>
<div class="og-rich"><p>Mute a noisy contact’s statuses in <strong>OG WhatsApp</strong> without nuking the whole chat—nice when one person floods stories all day.</p></div>

<h3>Status Length</h3>
<div class="og-rich"><p>Like other mods, <strong>OG WhatsApp</strong> often stretches status video length past the stock cap—good for short tutorials when your build supports it.</p></div>

<h3>Calling Numbers</h3>
<div class="og-rich"><p>Voice and video in <strong>OG WhatsApp</strong> still feel like WhatsApp-style calling; some forks add small UI flourishes on top.</p></div>

<h3>Setting Group Name</h3>
<div class="og-rich"><p><strong>OG WhatsApp</strong> usually relaxes group name length so clubs and work teams aren’t stuck with awkward abbreviations.</p></div>

<h3>Call Blocker</h3>
<div class="og-rich"><p>Block calls from specific numbers inside <strong>OG WhatsApp</strong> while keeping text open—handy when clients text updates but ring you nonstop.</p></div>

<h3>Create a Call Link</h3>
<div class="og-rich"><p>Drop-in call links from <strong>OG WhatsApp</strong> help when you don’t want to save every guest as a contact before a one-off meeting.</p></div>

<h3>Dual WhatsApp</h3>
<div class="og-rich"><p><strong>OG WhatsApp</strong> is the kind of mod people pick when they want two accounts on one phone—work and personal—without carrying a second device, when the package supports it.</p></div>

<h3>Customization Features</h3>
<div class="og-rich"><p><strong>OG WhatsApp</strong> skins are the fun half—when your build includes them:</p></div>
<ul class="og-icon-list og-icon-list--check">
  <li><strong>Themes:</strong> light/dark/color packs where included.</li>
  <li><strong>Fonts & bubbles:</strong> tune readability and style.</li>
  <li><strong>Icons & wallpapers:</strong> make the app feel like yours.</li>
</ul>
<div class="og-rich"><p>Open <strong>Settings → Customization</strong> on your build and tweak safely—if something looks unstable after a theme switch, revert before updating.</p></div>

<h3>Privacy</h3>
<div class="og-rich"><p>Privacy is personal. <strong>OG WhatsApp</strong> usually layers granular controls on top of stock WhatsApp:</p></div>
<ul class="og-icon-list og-icon-list--check">
  <li><strong>Hide online status</strong> for everyone, contacts only, or per-contact rules on supported builds.</li>
  <li><strong>Hide blue ticks</strong> so you can read first and reply later—use responsibly.</li>
  <li><strong>Hide typing</strong> while you compose.</li>
  <li><strong>Hide last seen</strong> with finer rules on many forks.</li>
  <li><strong>Lock chats</strong> with PIN / fingerprint when the build includes it.</li>
</ul>

<h3>Security</h3>
<div class="og-rich"><p>Any mod—including <strong>OG WhatsApp</strong>—shifts your trust model. Habits beat buzzwords:</p></div>
<ul class="og-icon-list og-icon-list--check">
  <li>Prefer <strong>one publisher</strong> you chose on purpose; avoid hopping between random mirrors.</li>
  <li><strong>Update</strong> when release notes mention security or compatibility fixes.</li>
  <li>Don’t treat banking passwords or highly sensitive secrets as “fine in any chat app.”</li>
  <li>If something looks off (new permissions, sudden crashes), <strong>stop</strong> and verify before continuing.</li>
</ul>
<div class="og-callout og-callout--warning"><span class="og-callout__icon" aria-hidden="true">⚠</span><div>No mod is 100% risk-free—pair tools with common sense.</div></div>
<div class="og-callout og-callout--tip"><span class="og-callout__icon" aria-hidden="true">✓</span><div><strong>Habit:</strong> backup before updates; keep screenshots of your build version for support threads.</div></div>

<h3>Messages</h3>
<div class="og-rich"><p>Handy <strong>OG WhatsApp</strong> message extras people turn on early (depends on build):</p></div>
<ul class="og-icon-list og-icon-list--check">
  <li><strong>Schedule messages</strong> for reminders and birthdays.</li>
  <li><strong>Forward without “forwarded” label</strong> on some builds—use ethically.</li>
  <li><strong>More pinned chats</strong> than the stock cap on many mods.</li>
  <li><strong>Message timers / self-destruct style options</strong> where included.</li>
</ul>

<h3>Media sharing</h3>
<div class="og-rich"><p><strong>OG WhatsApp</strong> forks often bump practical send limits so you squash fewer photos and clips:</p></div>
<ul class="og-icon-list og-icon-list--check">
  <li>Larger photo/video sends on supported builds.</li>
  <li>Bigger multi-select batches for albums and trip photos.</li>
  <li>Optional compression when you need to save data.</li>
  <li>Control auto-save rules per chat when available.</li>
</ul>

<h3>Language</h3>
<div class="og-rich"><p><strong>OG WhatsApp</strong> lets you pick a UI language that matches how you think—especially if English isn’t your first language.</p></div>

<h3>Do Not Disturb (DND)</h3>
<div class="og-rich"><p><strong>OG WhatsApp</strong> DND quiets WhatsApp-style pings for a window without silencing the whole phone—meetings, study blocks, that sort of thing.</p></div>

<h2>Quick Features Comparison: OG WhatsApp vs Simple WhatsApp</h2>
<div class="og-rich"><p>If you’re deciding whether to sideload, this table summarizes the usual “why people switch” differences—confirm in your installed settings because forks vary.</p></div>
<!--TABLE_PLACEHOLDER_COMPARE-->

<h2>OG WhatsApp Backup And Restore</h2>
<div class="og-rich"><p>Losing chat history hurts—backups are your safety net. OG-style clients usually follow the same backup idea as WhatsApp: cloud or local, then restore during setup.</p></div>
<ul class="og-icon-list og-icon-list--check">
  <li>Open <strong>Settings → Chats → Chat backup</strong> inside the mod.</li>
  <li>Choose what to include (messages/media) based on what your build supports.</li>
  <li>On reinstall or new phone, tap <strong>Restore</strong> when prompted—large backups take time.</li>
</ul>
<div class="og-rich"><p>Backup <strong>before</strong> updates when the release notes mention database changes.</p></div>

<h2>Can OG WhatsApp Connect to Web?</h2>
<div class="og-rich"><p>Yes—many builds still support Web-style pairing. Open <strong>web.whatsapp.com</strong> on your computer, then use the mod’s <strong>Linked devices / WhatsApp Web</strong> flow to scan the QR code. Your phone must stay online; Web mirrors your phone session.</p></div>

<h2>Regular OG WhatsApp Updates</h2>
<div class="og-rich"><p>Updates matter for compatibility and fixes. Check ogbwhats.com for newer builds, install over the existing app when your publisher recommends it, and keep backups before big jumps.</p></div>

<h2>Conclusion</h2>
<div class="og-rich">
  <p>OG WhatsApp isn’t for everyone—but if you want more privacy controls, customization, and account flexibility on Android, it’s a common choice. Keep expectations honest: it’s a mod, not Meta’s official app.</p>
  <p>For a wider GB mod comparison, readers can also review <a href="https://androidwaves.org/gb-whatsapp-apk/" target="_blank" rel="noopener">GB WhatsApp</a> coverage and the <a href="https://gbwhataps.com/" target="_blank" rel="noopener">Download GB WhatsApp</a> resource before choosing a build.</p>
  <p>If you’re ready, start with the <a href="/download/">latest OG WhatsApp APK</a>, read the <a href="/disclaimer/">disclaimer</a>, and compare forks in <a href="/og-whatsapp-vs-gb-whatsapp/">OG WhatsApp vs GB WhatsApp</a> when you’re unsure what fits you.</p>
</div>
`;

export function buildOgArticleHtml() {
  return (
    introHtml +
    bodyAfterIntroHtml
      .replace('<!--TABLE_PLACEHOLDER_FILEINFO-->', fileInfoTableHtml)
      .replace('<!--TABLE_PLACEHOLDER_COMPARE-->', comparisonTableHtml)
  );
}
